import * as React from "react";
const SvgFiRrTrainJourney = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-train-journey_svg__a)">
      <path
        fill="#062147"
        d="M17.26 10.292a2.48 2.48 0 0 0 1.74.715c.626 0 1.252-.238 1.74-.715l1.795-1.756a5.006 5.006 0 0 0 0-7.071A4.97 4.97 0 0 0 19 .001c-1.335 0-2.592.52-3.535 1.464a5.01 5.01 0 0 0 .008 7.079zm-.381-7.414A2.98 2.98 0 0 1 19 2a3 3 0 0 1 2.129 5.114l-1.787 1.748a.486.486 0 0 1-.684 0l-1.779-1.74a3.004 3.004 0 0 1 0-4.244m3.122 1.909a1 1 0 1 1-2 0 1 1 0 0 1 2 0M24 18c0 2.206-1.794 4-4 4h-7a1 1 0 1 1 0-2h7c1.103 0 2-.897 2-2s-.897-2-2-2h-8c-2.206 0-4-1.794-4-4s1.794-4 4-4a1 1 0 1 1 0 2c-1.103 0-2 .897-2 2s.897 2 2 2h8c2.206 0 4 1.794 4 4m-14.884-.454A3.98 3.98 0 0 0 5.389 15H1a1 1 0 1 0 0 2h2v3H1a1 1 0 1 0 0 2h1v.5a1.5 1.5 0 0 0 3 0 1.5 1.5 0 0 0 3 0V22c1.299 0 2-1.03 2-2a1 1 0 0 0-.068-.363l-.815-2.09zM5 20v-3h.39c.83 0 1.562.5 1.863 1.273L7.927 20z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-train-journey_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTrainJourney;
